import * as yup from 'yup'

import constants from 'constants/index'

const { ALL_SOLICITATION_CATEGORIES } = constants.faqs

const schema = yup.object().shape({
  category: yup
    .string()
    .oneOf(ALL_SOLICITATION_CATEGORIES, 'Tipo de atendimento inválido')
    .required(),
  title: yup.string().required().max(255),
  description: yup.string().required().max(5000),
  files: yup.mixed().fileUpload(),
})

export default schema
